angular.module('bribac.views.forgotPassword', [
  'ngRoute',
  'bribac.translations',
  'bribac.services.routeAuth',
  'bribac.services.api'
])

  .config(function(
    $routeProvider
  ) {
    $routeProvider.when('/forgot-password', {
      templateUrl: 'forgot-password-view.html',
      controller: 'ForgotPasswordViewCtrl',
      controllerAs: '$ctrl',
      resolve: {access: function(routeAuth) {return routeAuth.requireUnauth()}}
    })
  })

  .controller('ForgotPasswordViewCtrl', function(
    api
  ) {

    var $ctrl = this

    $ctrl.onSubmit = function() {
      var $form = $ctrl.form

      if ($form.$invalid) {
        return
      }

      $form._submitting = true
      $form._submitError = ''

      api.forgotPassword($ctrl.email)
        .then(
          function success() {
            $ctrl.resetEmailSent = true
          },
          function error(request) {
            $form._submitError = request.statusText
          }
        )
        .finally(function() {
          $form._submitting = false
        })
    }
  })
